import React, { useContext, useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import strings from '../../lang/strings'
import { observer } from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import { MenuMy } from '../../config/page_route'
import AppInput1 from '../../components/control/custom_input/app_input1'
import AppTextarea from '../../components/control/custom_input/app_textarea'
import ConfirmButton from '../../components/control/button/confirm_button'
import { rootStore } from '../../mobx/store'
import { checkPwd, fphoto, htmlToText } from '../../helper/common'
import NormalButton from '../../components/control/button/normal_button'
import { API_URL, MaleUrl } from '../../config/const'
import ToggleButton from '../../components/control/button/toggle_button'

const Member = observer((props) => {
  const context = useContext(Page_settings)
  const fileRef = useRef()
  let [photo, setPhoto] = useState(rootStore.getMe.mb_photo)
  let [pwd, setPwd] = useState('')
  let [pwdD, setPwdD] = useState('')
  let [phone, setPhone] = useState(rootStore.getMe.mb_tel)
  let [intro, setIntro] = useState(rootStore.getMe.mb_intro)
  let [avgUpload, setAvgUpload] = useState(rootStore.getMe.mb_avgUpload)
  let [detail, setDetail] = useState(htmlToText(rootStore.getMe.mb_detail))
  let [emailAlarm, setEmailAlarm] = useState(rootStore.getMe.mb_is_alarm == 1)
  let [pwdError, setPwdError] = useState('')
  let [pwdDError, setPwdDError] = useState('')
  let [phoneError, setPhoneError] = useState('')
  let [introError, setIntroError] = useState('')
  let [nicknameError, setNicknameError] = useState('')
  let [nickname, setNickname] = useState(rootStore.getMe.mb_nick)
  let [avgUploadError, setAvgUploadError] = useState('')

  const [activePwd, setActivePwd] = useState(false);
  const activePwdRef = useRef(false);

  const [activeNick, setActiveNick] = useState(false);
  const activeNickRef = useRef(false);

  const active = 0

  useEffect(() => {
    context.getPoint()
  }, [])

  useEffect(() => {
    setPwdError('')
  }, [pwd])

  useEffect(() => {
    setPwdDError('')
  }, [pwdD])

  useEffect(() => {
    setPhoneError('')
  }, [phone])

  useEffect(() => {
    setIntroError('')
  }, [intro])

  useEffect(() => {
    setPwd('');
    setPwdD('');
    activePwdRef.current = activePwd;
  }, [activePwd]);

  useEffect(() => {
    setNicknameError('');
    setNickname(rootStore.getMe.mb_nick);
    activeNickRef.current = activeNick;
  }, [activeNick]);

  const onSave = () => {
    let checked = true

    let mb = rootStore.getMe
    if (mb.mb_social == 1) {
      if (activePwdRef.current && pwd !== '') {
        if (!checkPwd(pwd)) {
          checked = false
          setPwdError(strings.invalid_pwd)
        }
        if (mb.pwd === pwd) {
          checked = false
          setPwdError(strings.pwd_old_erro)
        }
        if (pwdD === '') {
          checked = false
          setPwdDError(strings.pwd_hint)
        }
        if (pwdD !== '' && pwd !== pwdD) {
          checked = false
          setPwdDError(strings.pwd_mismatch)
        }
      }

      if (phone === '') {
        checked = false
        setPhoneError(strings.phone_hint)
      }
      if (phone !== '' && phone.replace(/-/g, '').replace(/_/g, '').length !== 11) {
        checked = false
        setPhoneError(strings.invalid_hint)
      }
    }

    if (intro !== '' && (intro.length > 30 || intro.length < 2)) {
      checked = false
      setIntroError(strings.intro_simple_error)
    }

    if (avgUpload !== '' && (avgUpload.length > 30 || avgUpload.length < 2)) {
      checked = false
      setAvgUploadError(strings.intro_simple_error)
    }

    let updateNick = '';
    if (activeNickRef.current) {
      if (nickname == '') {
        checked = false;
        context.showAlert(strings.nickname_hint)
        setNicknameError(strings.nickname_hint)
      } else {
        updateNick = nickname;
      }
    }

    if (!checked) return

    context.post('member/update', { pwd: pwd, tel: phone, intro: intro, detail: detail, avgUpload: avgUpload, nickname: updateNick },
      () => {
        let mb = rootStore.getMe
        if (activePwdRef.current && pwd !== '') mb.pwd = pwd
        mb.mb_tel = phone
        mb.mb_intro = intro
        mb.mb_detail = detail
        mb.mb_avgUpload = avgUpload
        if (activeNickRef.current && updateNick != '') mb.mb_nick = updateNick
        rootStore.signIn(mb)
        context.showAlert(strings.modify_complete)
      },
      true,
      err => {
        context.showAlert(err.msg)
        if (err.result == 503) {
          setNicknameError(err.msg)
        }
      }
    )
  }

  const changeAlarm = () => {
    const alarm = emailAlarm ? 0 : 1
    context.post('member/setAlarm', { alarm: alarm },
      () => {
        let mb = rootStore.getMe
        mb.mb_is_alarm = alarm
        rootStore.signIn(mb)
        setEmailAlarm(!emailAlarm)
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  // const uploadPhoto = (event) => {
  //   if (event.target.files.length < 1) return

  //   let file = event.target.files[0]
  //   let formData = new FormData()
  //   formData.append('photo', file)
  //   context.post('member/update_photo',
  //     formData,
  //     response => {
  //       let mb = rootStore.getMe
  //       mb.mb_photo = response.mb_photo
  //       rootStore.signIn(mb)
  //       setPhoto(response.mb_photo)
  //     },
  //     true,
  //     err => {
  //       context.showAlert(err.msg)
  //     }
  //   )
  // }

  const goToProductInfo = () => {
    props.history.push('/product_info');
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMy} active={active} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.mypage} pageMenu1={strings.main} pageMenu2={strings.mypage} pageMenu={strings.info_modify} />
          <div className='term-content-area2'>
            <div className='fs-20 sm-fs-16 mb-20 sm-mb-14 f-b'>{strings.info_modify}</div>
            {rootStore.getMe.mb_lv > 1 &&
              <div className='member-profile-header'>
                <div>
                  <div>
                    <img className='winee-bj-profile' src={fphoto(photo, 'member', MaleUrl)} alt={''} />
                  </div>
                </div>

                <div>
                  <NormalButton name={strings.my_product_info} style={{ backgroundColor: '#0f4c81', color: '#fff' }} onClick={goToProductInfo}></NormalButton>
                </div>

              </div>
            }
            <AppInput1 className={'mt-18 sm-mt-12'} errorMsg={''} placeholder={strings.email} id={'email'} required={true} readonly={true} inputType={'email'} value={rootStore.getMe.mb_email} onChange={(v) => { }} />
            {rootStore.getMe.mb_social == 1 &&
              <>
                <div className={'mt-18 sm-mt-12 sm-none'} >
                  <span style={{ fontSize: '14px' }}>비밀번호 변경</span>
                  <ToggleButton state={activePwd} onClick={setActivePwd}></ToggleButton>
                </div>
                <div className='d-flex-block'>
                  <div className={'sm-mt-12 sm-inherit'} >
                    <span style={{ fontSize: '14px' }}>비밀번호 변경</span>
                    <ToggleButton state={activePwd} onClick={setActivePwd}></ToggleButton>
                  </div>
                  <AppInput1 className={'mt-14 sm-mt-12 flex-full'} readonly={!activePwd} errorMsg={pwdError} placeholder={strings.pwd} id={'pwd'} required={true} inputType={'password'} value={pwd} onChange={(v) => { setPwd(v.target.value) }} />
                  <AppInput1 className={'mt-14 sm-mt-12 flex-full ml-25 sm-ml-0'} readonly={!activePwd} errorMsg={pwdDError} placeholder={strings.pwd_d} id={'pwdD'} required={true} inputType={'password'} value={pwdD} onChange={(v) => { setPwdD(v.target.value) }} />
                </div>
              </>
            }
            <>
              <div className={'mt-18 sm-mt-12 sm-none'} >
                <span style={{ fontSize: '14px' }}>닉네임 변경</span>
                <ToggleButton state={activeNick} onClick={setActiveNick}></ToggleButton>
              </div>
              <div className='d-flex-block'>
                <div className={'sm-mt-12 sm-inherit'} >
                  <span style={{ fontSize: '14px' }}>닉네임 변경</span>
                  <ToggleButton state={activeNick} onClick={setActiveNick}></ToggleButton>
                </div>
                <AppInput1 className={'mt-18 sm-mt-12 w-100'} readonly={!activeNick} errorMsg={nicknameError} placeholder={strings.nickname_hint} inputType={'text'} value={nickname} onChange={(v) => { setNicknameError(''); setNickname(v.target.value) }} />
              </div>
            </>

            {rootStore.getMe.mb_social == 1 &&
              <AppInput1 className={'mt-18 sm-mt-12'} errorMsg={phoneError} placeholder={strings.phone} id={'phone'} required={true} readonly={true} inputType={'phone'} value={phone} onChange={(v) => { setPhone(v.target.value) }} />
            }
            <AppInput1 className={'mt-18 sm-mt-12'} errorMsg={''} placeholder={strings.name} id={'name'} required={true} readonly={true} inputType={'text'} value={rootStore.getMe.mb_name} onChange={(v) => { }} />
            <AppInput1 className={'mt-18 sm-mt-12'} errorMsg={''} placeholder={strings.birthday} id={'name'} required={true} readonly={true} inputType={'text'} value={rootStore.getMe.mb_birth} onChange={(v) => { }} />
            {rootStore.getMe.mb_lv > 1 &&
              <React.Fragment>
                <AppInput1 className={'mt-18 sm-mt-12'} errorMsg={introError} placeholder={strings.intro_simple} id={'intro'} maxLength={30} required={false} inputType={'text'} value={intro} onChange={(v) => { setIntro(v.target.value) }} />
                <div className={'mt-18 sm-mt-12'} />
                <AppInput1 className={'mt-18 sm-mt-12'} errorMsg={avgUploadError} placeholder={strings.intro_avg_upload} id={'upload_time'} maxLength={30} required={false} inputType={'text'} value={avgUpload} onChange={(v) => { setAvgUpload(v.target.value) }} />
                <div className={'mt-18 sm-mt-12'} />
                <AppTextarea placeholder={strings.intro_detail} errorMsg={''} value={detail} onChange={(v) => { setDetail(v.target.value) }}></AppTextarea>
              </React.Fragment>
            }
            <ConfirmButton enabled={true} className={'btn-save fs-15 sm-fs-14 f-sb '} onClick={() => { onSave() }} text={strings.save} />
          </div>
          <button className='sidebar-logout btn btn-white fs-14 sm-fs-12 f-m d-center mt-20 sm-mt-10' onClick={() => { context.showSignout() }}>{strings.signout}</button>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(Member)
